// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#pending-cases-view .cpt-codes .indicatives ul {\n  display: flex;\n  row-gap: 10px;\n}\n#pending-cases-view .cpt-codes .indicatives ul li {\n  margin: 0 5px;\n  width: 45px;\n  text-align: center;\n}\n#pending-cases-view .cpt-codes .indicatives ul li p .value {\n  padding: 3px 12px !important;\n}\n.case-status {\n  height: 50px;\n  display: flex;\n  align-items: center;\n  margin-bottom: 0;\n  justify-content: end;\n}\n.case-status li button {\n  cursor: default;\n}", ""]);
// Exports
module.exports = exports;
